import { DeletePinMutation2z9xaiydj80c8 as DeletePinMutation } from './schema/DeletePinMutation.mjs';
import { voidResult3hb4jxf0f2mcw as voidResult } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/VoidResult.mjs';
import { Dispatcher2txct93ff9b99 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePinInputmel7ixrs09hz as DeletePinInput } from './schema/type/DeletePinInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0_safe_receiver = (yield* this.c6x(new (DeletePinMutation())(deletePinInput(command.c2n_1, command.d2n_1)), $completion)).r44_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w6h_1;
  return voidResult(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
}
var SdkDeletePinCommandDispatcherClass;
function SdkDeletePinCommandDispatcher() {
  if (SdkDeletePinCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkDeletePinCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkDeletePinCommandDispatcherClass = $;
  }
  return SdkDeletePinCommandDispatcherClass;
}
function deletePinInput(partyId, pinId) {
  return new (DeletePinInput())(partyId, pinId);
}
//region block: exports
export {
  SdkDeletePinCommandDispatcher as SdkDeletePinCommandDispatcher31mrzwlipmcuz,
  perform as perform1xozcao2fibmc,
};
//endregion

//# sourceMappingURL=SdkDeletePinCommandDispatcher.mjs.map
